import React, { forwardRef, useImperativeHandle } from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PropTypes from 'prop-types'

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />
})

const ModalBox = forwardRef(
  (
    {
      modalStyle,
      children,
      title,
      size,
      onCloseModal,
      noWidth,
      fullScreen,
      disablePadding,
    },
    ref,
  ) => {
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.down('sm'))
    const [open, setOpen] = React.useState(false)

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
      openModal() {
        setOpen(true)
      },
      closeModal() {
        setOpen(false)
      },
    }))

    const iff = (condition, then, otherwise) => (condition ? then : otherwise)

    return (
      open && (
        <Dialog
          fullScreen={fullScreen}
          TransitionComponent={fullScreen ? Transition : 'Fade'}
          open={open}
          maxWidth={size}
          scroll="paper"
          PaperProps={{
            style: {
              ...modalStyle,
              overflow: 'unset',
              border: `1px solid ${'#FFFFFF33'}`,
              backgroundColor:
                theme.palette.mode === 'light'
                  ? '#fff'
                  : theme.palette.background.default,
              width: size && noWidth ? '100%' : '',
              backgroundImage: 'initial',
              borderRadius: '16px',
              '& .MuiDialogContent-root': {
                padding: disablePadding ? 0 : '40px',
              },
            },
          }}
          sx={{
            '& .MuiDialog-paperFullScreen': {
              '& .MuiDialogContent-root': {
                padding: iff(disablePadding, 0, matches ? '20px' : '40px'),
              },
            },
          }}
        >
          {title && <DialogTitle sx={{ p: 3 }}>{title}</DialogTitle>}
          <IconButton
            disableRipple
            size="small"
            aria-label="close"
            onClick={() => {
              setOpen(false)
              onCloseModal()
            }}
            sx={{
              position: 'absolute',
              right: matches ? 5 : 10,
              top: matches ? 5 : 15,
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent
            sx={{
              p: disablePadding ? 0 : null,
              pl: disablePadding ? 0 : 3,
              pr: disablePadding ? 0 : 3,
            }}
          >
            {children}
          </DialogContent>
        </Dialog>
      )
    )
  },
)

export default ModalBox

ModalBox.defaultProps = {
  title: '',
  size: '',
  onCloseModal: () => {},
  noWidth: true,
  fullScreen: false,
  modalStyle: {},
  disablePadding: false,
}

ModalBox.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  size: PropTypes.string,
  onCloseModal: PropTypes.func,
  noWidth: PropTypes.bool,
  fullScreen: PropTypes.bool,
  modalStyle: PropTypes.shape({}),
  disablePadding: PropTypes.bool,
}
